import { ISendAprovacaoColetaPrecoUseCase } from "../../../presentation/useCases/update/send_aprovacao_coleta_preco_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * SendAprovacaoColetaPrecoUseCase
 */

export class SendAprovacaoColetaPrecoUseCase implements ISendAprovacaoColetaPrecoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async sendAprovacaoColetaPreco(
    idColetaPreco: number,
    subject: string,
    body: string,
  ): Promise<void> {
    await this.repository.sendAprovacaoColetaPreco(
      idColetaPreco,
      subject,
      body,
    );
  }
}
